import React, { Component } from "react";
import moment from 'moment';
import {
    getObjectType,
    getMethodType,
    getMethodValue,
    getMethodDescription,
    getMethodMeasure,
    getDateTime,
    UTCToLocal,
    getContent
} from '../../helper';
import TradeObjectInfo from './TradeObjectInfo';
import WorkPhotoListItem from './WorkPhotoListItem';
import WorkVideoListItem from './WorkVideoListItem';
import WorkUploadButton from './WorkUploadButton';
import WorkIsNotConverted from './WorkIsNotConverted';

import $ from "jquery";
window.jQuery = $;
require("@fancyapps/fancybox");

export default class ExecutorPhotos extends Component {
    state = {
        currentImage: 0,
        objectIndex: 0,
        imageIndex: 0,
        sliderShow: false,
    }

    showSlider(item, objectIndex, imageIndex) {
        if(item.src === '') return false;

        this.setState({
            currentImage: imageIndex,
            objectIndex,
            imageIndex,
            sliderShow: true
        })
    }

    handleSlideRight() {
        const {currentImage, objectIndex} = this.state;
        const {objectList} = this.props;
        if(!objectList || !objectList.length) return false;
        const length = objectList[objectIndex].photos.length;

        if(currentImage < length) {
            this.setState({
                currentImage: this.state.currentImage + 1
            })
        }
    }

    handleSlideLeft() {
        const {currentImage} = this.state;
        const {objectList} = this.props;
        if(!objectList || !objectList.length) return false;

        if(currentImage !== 0) {
            this.setState({
                currentImage: this.state.currentImage - 1
            })
        }
    }

    getFileType(data) {
        let order_method = data.order_method || {};
        let method_type = order_method.method_type || {};
        return (method_type.is_video || false);
    }

    calculatePhotos(object, isCustomer) {
        if(!object || !object.order_position || isCustomer) return null;

        let {order_position} = object;
        let isVideo = this.getFileType(order_position);
        let photoCount = order_position.photos_ordered || 0;

        let media = object.photos || [];

        if(!media.length || isVideo || media.length < photoCount) return null;
       // if(!media.length || !is_photo) return null;
        ///Должно быть уведомление, например, для данного случая (если мы грузим больше работ, чем требуется):
        //"выполнено 3 из 3-х, возможно загрузить 6 запасных для выбора по качеству".

        return {
            photoCountMax: (photoCount*3),
            mediaLength: media.length,
            photoCount,
        }
    }

    getMediaText(object, isCustomer) {
        let results = this.calculatePhotos(object, isCustomer);
        if(!results) return false;

        let extra = (results.photoCountMax - results.mediaLength);

        return  <div className="success-color-media">
                    {`Выполнено ${results.mediaLength} из ${results.photoCount}, возможно загрузить ${extra} запасных для выбора по качеству`}
                </div>
    }

    getMediaText3(object) {
        if(!object || !object.order_position) return null;

        let {order_position} = object;
        let isVideo = this.getFileType(order_position);
        if(isVideo || this.props.currentOrder.status === 9) return null;

        let photoCount = order_position.photos_ordered || 0;
        let media = object.photos || [];

        if(!media.length || media.length >= photoCount) return null;

        return  <div style={{padding: "20px", width: "100%", background: "rgb(255, 219, 172)", marginBottom: '20px', color: "rgb(51, 51, 51)", fontSize: "15px"}}>
                    Работа выполнена не полностью.
                </div>
    }

    uploadedLate(created, lastdate) {
        return (moment(lastdate).diff(moment(created).format('MM/DD/YYYY HH:mm'), 'minutes') < 0);
    }

    render() {
        const {
            isLoggedIn,
            isCustomer,
            executor,
            objectList,
            uploadWorks,
            uploadState,
            deleteImageInServer,
            deleteVideoInServer,
            currentOrder,
            settings,
            currentUserId,
            endShootingDatetime,
        } = this.props;

        let itsMyBid = (currentUserId === executor.user_id);
        let btnDisable = true;

        if(
            isLoggedIn && !isCustomer && currentOrder.is_my_bid &&
            currentOrder.allow_upload_results_from_web &&
            (executor.status === 2 || executor.status === 3) &&
            (currentOrder.status === 3 || currentOrder.status === 4)
        ) {
            btnDisable = false;
        }

        if(currentOrder.status === 4 || !itsMyBid) {
            btnDisable = true;
        }

        return  (
            <div>

                {
                    objectList && objectList.map((object, objectIndex) => {
                        let isVideo = this.getFileType(object.order_position);
                        let isUploadedVideos = object.videos.filter(item => item.video && !item.is_converted);
                        let calcPhotos = this.calculatePhotos(object, false);
                        let uploadBtnDisable = true;

                        if(
                            itsMyBid &&
                            currentOrder.allow_upload_results_from_web &&
                            (executor.status === 2 || executor.status === 3) &&
                            (currentOrder.status === 3 || currentOrder.status === 4)
                        ) {
                            uploadBtnDisable = false;
                        }

                        if(calcPhotos) {
                            if(calcPhotos.photoCountMax === calcPhotos.mediaLength) {
                                uploadBtnDisable = true;
                            }
                        }

                        return  <div className="filming-order" key={objectIndex}>
                                    <h3 style={{marginBottom:'10px'}}>ОБЪЕКТЫ СЪЕМКИ: {'№' + (objectIndex+1)}</h3>

                                    <TradeObjectInfo
                                        objectIndex={objectIndex}
                                        object={object}
                                    />

                                    {
                                        (executor.status === 2 || executor.status === 3) && !isCustomer && itsMyBid
                                        ? this.getMediaText(object, isCustomer)
                                        : null
                                    }

                                    <ul className="examples">
                                        {
                                            (object.photos || []).map((item, index) => {
                                                let pictureUploadedLate = this.uploadedLate(moment(moment(item.created_at).format('MM/DD/YYYY HH:mm')), endShootingDatetime);

                                                return  <WorkPhotoListItem
                                                            key={index}
                                                            item={item}
                                                            index={index}
                                                            btnDisable={btnDisable}
                                                            pictureUploadedLate={pictureUploadedLate}
                                                            showSlider={() => this.showSlider(item, objectIndex, index)}
                                                            deleteImageInServer={() => deleteImageInServer(item, executor.id)}
                                                        />
                                            })
                                        }

                                        {
                                            (object.videos || []).map((item, index) => {
                                                if(!item.video && !item.thumb_image) return false;

                                                let pictureUploadedLate = this.uploadedLate(moment(moment(item.created_at).format('MM/DD/YYYY HH:mm')), endShootingDatetime);

                                                if(item.video) {
                                                    if(!item.is_converted) {
                                                        return  <WorkIsNotConverted
                                                                    key={index}
                                                                    item={item}
                                                                    index={index}
                                                                    btnDisable={btnDisable}
                                                                    pictureUploadedLate={pictureUploadedLate}
                                                                    deleteVideoInServer={() => deleteVideoInServer(item, executor.id)}
                                                                />
                                                    }

                                                    return  <WorkVideoListItem
                                                                key={index}
                                                                item={item}
                                                                index={index}
                                                                btnDisable={btnDisable}
                                                                pictureUploadedLate={pictureUploadedLate}
                                                                deleteVideoInServer={() => deleteVideoInServer(item, executor.id)}
                                                            />
                                                }

                                                return  <WorkPhotoListItem
                                                            key={index}
                                                            item={item}
                                                            index={index}
                                                            btnDisable={btnDisable}
                                                            pictureUploadedLate={pictureUploadedLate}
                                                            showSlider={() => this.showSlider(item, objectIndex, index)}
                                                        />
                                            })
                                        }

                                        {

                                            <WorkUploadButton
                                                isVideo={isVideo}
                                                uploadState={uploadState[object.id]}
                                                btnDisable={uploadBtnDisable}
                                                inputTypeFileValue={this.props.inputTypeFileValue}
                                                allow_upload_only_mp4={settings.allow_upload_only_mp4}
                                                uploadWorks={(e) => uploadWorks(e, executor.id, object.id, isVideo)}
                                            />
                                        }

                                        {
                                            uploadBtnDisable && ![...object.photos, ...object.videos].length ?
                                            <div>Результаты не загружены</div> : null 
                                        }
                                    </ul>

                                    {
                                        isUploadedVideos.length ?
                                        <div style={{padding:'15px', background:'rgb(255, 219, 172)'}}>
                                            Видео будет доступно для просмотра после загрузки и конвертации на сервере
                                        </div>
                                        : null
                                    }

                                    {
                                        isCustomer === true && (executor.status === 2 || executor.status === 3)
                                        ?   this.getMediaText3(object)
                                        : null
                                    }

                                </div>
                    })
                }
                
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/ExecutorPhotos.js